export default "__VITE_ASSET__BAuFM$43__"